'use client'

import { useState } from 'react'

const STORAGE_KEY = 'bodi-recent-searches'
const MAX_ENTRIES = 5

export function useRecentSearches() {
  const [recentSearches, setRecentSearches] = useState<string[]>(() => {
    if (typeof window === 'undefined') return []

    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      return stored ? JSON.parse(stored) : []
    } catch {
      return []
    }
  })

  const addRecentSearch = (query: string) => {
    const trimmed = query.trim()
    if (!trimmed) return

    setRecentSearches((prev) => {
      const deduped = [trimmed, ...prev.filter((q) => q !== trimmed)].slice(0, MAX_ENTRIES)
      localStorage.setItem(STORAGE_KEY, JSON.stringify(deduped))

      return deduped
    })
  }

  const clearRecentSearches = () => {
    setRecentSearches([])
    localStorage.removeItem(STORAGE_KEY)
  }

  return { recentSearches, addRecentSearch, clearRecentSearches }
}
